import createPlotlyComponent from "react-plotly.js/factory";

// Central Plotly component.
// Plotly itself is loaded as a plain script tag in `public/index.html`, from the
// self-hosted copy in `public/vendor/`. Do not switch to the CDN (some clients block
// it) or to an npm import of plotly.js (it breaks our build). See index.html.
const Plot = createPlotlyComponent((window as any).Plotly);

export default Plot;

